<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div style="padding: 15px;" v-show="showSearch">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
				<div style="height: 50px;"></div>
				<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
				<van-field v-model="stuForm.exam_num" label="考试证号" placeholder="请输入考试证号/准考证号/建档号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>
		</div>


		<div style="padding: 15px;" v-show="showInfo">
			<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
			<div class="rowlb">
				<span></span>
				个人信息
			</div>
			<van-cell-group>

				<van-field :readonly="true" v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" />
				<van-field label="性别">

					<template #input>
						{{stuForm.gender==1?'男':''}}
						{{stuForm.gender==2?'女':''}}
						{{stuForm.gender==''?'未知':''}}
					</template>
				</van-field>

				<van-field :readonly="true" v-model="stuForm.graduate_sch_city" label="中考地区" placeholder="中考地区" />
				<van-field :readonly="true" v-model="stuForm.major_name" label="专业名称" placeholder="专业名称" />

				<van-field readonly v-model="stuForm.exam_num" label="考试证号" placeholder="考试证号" />
				
				<van-field readonly v-model="stuForm.exam_score" label="中考分数" placeholder="中考分数" />

				<!-- <van-field v-model="stuForm.phone" type="tel" label="手机号" placeholder="请输入手机号" required /> -->
				<div class="rowlb">
					<span></span>
					学生完善信息
				</div>
				
				<van-field label="是否走读">
				
					<template #input>
						<van-radio-group v-model="pjson.zoudu" direction="horizontal">
							<van-radio :name="1">是</van-radio>
							<van-radio :name="0">否</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				
<!-- 				
				<van-field v-model="pjson.height" label="身高(CM)" type="digit" placeholder="请输入身高数字">
				</van-field>
				<van-field v-model="pjson.weight" label="体重(KG)" type="digit" placeholder="请输入体重数字">
				</van-field>

				<div class="rowlb">
					<span></span>
					军训服尺码
					<div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">
					</div>

				</div>

				<div id="">
					<table class="datatable" cell-spacing="1" cell-padding="0" style="font-size: 12px;">
						<tr>
							<th style="width: 10%;">型号</th>
							<th style="width: 10%;">M</th>
							<th style="width: 10%;">L</th>
							<th style="width: 10%;">XL</th>
							<th style="width: 10%;">2XL</th>
							<th style="width: 10%;">3XL</th>
							<th style="width: 10%;">4XL</th>
							<th style="width: 10%;">5XL</th>
							<th style="width: 10%;">6XL</th>
							<th style="width: 10%;">其他</th>

						</tr>
						<tr>
							<td>建议身高</td>
							<td>150-155</td>
							<td>155-160</td>
							<td>160-165</td>
							<td>165-170</td>
							<td>170-175</td>
							<td>175-180</td>
							<td>180-185</td>
							<td>185-190</td>
							<td>特殊体型</td>
						</tr>
						<tr>
							<td>体重(kg)</td>
							<td>45-50</td>
							<td>50-55</td>
							<td>55-60</td>
							<td>60-65</td>
							<td>65-70</td>
							<td>70-75</td>
							<td>75-80</td>
							<td>80-85</td>
							<td>特殊体型</td>
						</tr>
						<tr style="cursor: pointer;">
							<td>点击选择</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='M'">
								<i class="el-icon-success" v-if="pjson.size=='M'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='L'">
								<i class="el-icon-success" v-if="pjson.size=='L'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='XL'">
								<i class="el-icon-success" v-if="pjson.size=='XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='2XL'">
								<i class="el-icon-success" v-if="pjson.size=='2XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='3XL'">
								<i class="el-icon-success" v-if="pjson.size=='3XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='4XL'">
								<i class="el-icon-success" v-if="pjson.size=='4XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='5XL'">
								<i class="el-icon-success" v-if="pjson.size=='5XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='6XL'">
								<i class="el-icon-success" v-if="pjson.size=='6XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="pjson.size='O'">
								<i class="el-icon-success" v-if="pjson.size=='O'"></i>
							</td>
						</tr>
					</table>
				</div>

				<van-field v-if="pjson.size=='O'" v-model="pjson.remark" label="特殊体型说明" placeholder="请输入特殊体型说明">
				</van-field>
				
				
				
				<div class="rowlb">
					<span></span>
					鞋码
					<div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">
					</div>
				
				</div>
				
				<div style="padding: 10px;">
					<div :class="['xm',item==pjson.shoes?'xmckd':'']" v-for="(item,idx) in shoes" :key="idx" @click="pjson.shoes=item">
						{{item}}
					</div>
				</div>
 -->



				<div class="submitBtn flexAround">
					<div class="btn" @click="saveStu()" style="width: 40%;">提交</div>
				</div>

				<div style="height:10px;"></div>


			</van-cell-group>


		</div>

		
	</div>
</template>

<script>
	import wx from 'weixin-js-sdk'
	import {
		Dialog,
		Toast
	} from 'vant';

	export default {
		components: {
			
		},
		data() {
			return {
				showInfo: false,
				showSearch: false,
				showClip: false,
				school_name: "",
				imgoldurl: '',
				pmid: 0,
				openid: "",
				disabled: false,
				stuForm: {
					

				},
				pjson: {
					identity_card1: "",
					identity_card2: "",
					hkb: "",
					zkz: "",
					score: "",
					jiaofei: "",
					height: "",
					weight: "",
					size: "",
					remark: "",
					shoes:"",
					zoudu:""

				},
				shoes:[35,36,37,38,39,40,41,42,43,44,45]
				
				
			}
		},
		mounted() {
			
			$(".page").height($(window).height())
			document.title = "请完善您的信息"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid
			if (!this.openid) {
				Dialog.alert({
					title: '网络错误',
					message: '未获取到微信授权用户信息，请重新扫码！',
					theme: 'round-button',
				}).then(() => {
					// on close
				});
			} else {
				window.pmid = this.pmid
				this.checkUrlSign(wx)
				this.getSchoolName();
				this.getStudents()
				
			}



		},
		methods: {
			
			getSchoolName() {
				this.$http.post("/api/app_platform_info", {
					pmid: this.pmid
				}).then(res => {
					this.school_name = res.data.platform
				})
			},
			getBirthdayFromIdCard: function(idCard) {
				var birthday = "";
				if (idCard != null && idCard != "") {
					if (idCard.length == 15) {
						birthday = "19" + idCard.substr(6, 6);
					} else if (idCard.length == 18) {
						birthday = idCard.substr(6, 8);
					}

					birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
				}

				return birthday;
			},
			onSearch() {

				this.$http.post("/api/app_luqu_check", {
					stu_name: this.stuForm.stu_name,
					stu_code: this.stuForm.exam_num,
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {

					if (res.data.id) {
						this.getStudents()
					} else if (res.data.id && res.data.status < 3) {
						Toast("该生已登记，但还未被录取！");
						this.showSearch = true
					} else {
						Toast("未找到录取信息！");
						this.showSearch = true
					}


					// if (res.data.id && res.data.status >= 3) {
					// 	this.getStudents()
					// } else if (res.data.id && res.data.status < 3) {
					// 	Toast("该生已登记，但还未被录取！");
					// 	this.showSearch = true
					// } else {
					// 	Toast("未找到录取信息！");
					// 	this.showSearch = true
					// }
				})
			},
			getStudents() {

				this.$http.post("/api/stuinfo_byopenid", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data.type == 'luqu') {
						if (res.data.stu) {
							this.showInfo = true
							this.showSearch = false;
							this.$http.post("/api/stu_luqu_detail", {
								stu_id: res.data.stu.id,
								pmid: this.pmid
							}).then(res => {
								let stu = res.data
								stu.phone = stu.phone || stu.jhr1phone || stu.jhr2phone
								if (stu.pjson) {
									stu.pjson = JSON.parse(stu.pjson)
									//合并对象
									for (let k in this.pjson) {
										if (!stu.pjson[k]) {
											stu.pjson[k] = this.pjson[k]
										}
									}


									this.pjson = stu.pjson
								}

								this.stuForm = stu
								


							})
						} else {
							Toast("该生已登记，但还未被录取！.");
							this.showSearch = true
						}
					} else if (res.data.type == 'baoming') {
						let stu = res.data.stu
						stu.phone = stu.phone || stu.jhr1phone || stu.jhr2phone
						if (stu.pjson) {
							stu.pjson = JSON.parse(stu.pjson)

							//合并对象
							for (let k in this.pjson) {
								if (!stu.pjson[k]) {
									stu.pjson[k] = this.pjson[k]
								}
							}


							this.pjson = stu.pjson
						}
						if (!stu.pjson && stu.otherjson) {
							stu.pjson = JSON.parse(stu.otherjson)
							//合并对象
							for (let k in this.pjson) {
								if (!stu.pjson[k]) {
									stu.pjson[k] = this.pjson[k]
								}
							}


							this.pjson = stu.pjson
						}
						stu.nowstatus = "baoming"
						this.stuForm = stu
						this.showSearch = false
						this.showInfo = true
					} else {
						this.showSearch = true
					}
				})

				//
			},

			saveStu() {
				this.stuForm.pjson = JSON.parse(JSON.stringify(this.pjson))
				
				this.$http.post("/api/h5_save_stumore", this.stuForm).then(res => {

					Dialog.alert({
						title: '完善信息',
						message: '提交成功！',
						theme: 'round-button',
					}).then(() => {
						// on close
					});
				})



			},


			showTips() {
				let _this = this
				Dialog.alert({
					title: "提示",
					message: '南京市中考考生填报：建档号和考试证号以中考准考证为准。江苏其他地区中考考生填报：中考准考证上只有1个号码的，建档号和考证号填写相同的。中考准考证上有2个号码的，分别将2个号码依次填写到建档号和考证号中。',
					messageAlign: 'left',
					showCancelButton: false,
					confirmButtonText: "关闭",
					confirmButtonColor: '#00cfdc',
				}).then(() => {
					console.log("点击了关闭按钮噢")


				}).catch(() => {
					console.log("点击了取消按钮噢")
				})
			},

			//户籍籍贯出生地
			onCheckCity1({
				selectedOptions
			}) {
				console.log(1, selectedOptions)
				this.showCity1 = false;
				this.stuForm.hkszd = selectedOptions.map((option) => option.label).join(',');
				this.stuForm.hkszd1 = selectedOptions[1].value
			},
			onCheckCity2({
				selectedOptions
			}) {
				console.log(2, selectedOptions)
				this.showCity2 = false;
				this.stuForm.jiguan = selectedOptions.map((option) => option.label).join(',');
				this.stuForm.jiguan1 = selectedOptions[1].value
			},
			onCheckCity3({
				selectedOptions
			}) {

				this.showCity3 = false;
				this.stuForm.hkszdpcs = selectedOptions.map((option) => option.label).join(',');
				this.stuForm.hkszdpcs1 = selectedOptions[1].value
			},

		},
	}
</script>

<style lang="less" type="text/less">
	.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #00cfdc;
  border-color: #00cfdc;
}
	.submitBtn {
        margin-top: 2vh;
		margin-bottom: 50px;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
			width: 50%;
			text-align:center;
        }
		.btn:active {

		    background-color: #007AFF;

		}
    }
	.xm{ border:1px solid #ccc; display: inline-block; margin:0 10px 10px 0; padding: 4px 10px; border-radius: 4px;}
	.xmckd{ background-color: orangered; color:#fff;}
</style>
